import { render, staticRenderFns } from "./IndependentLessonsList.vue?vue&type=template&id=2691248b"
import script from "./IndependentLessonsList.vue?vue&type=script&lang=js"
export * from "./IndependentLessonsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports